// JS-land brand tokens for consumers that can't use Tailwind classes
// (recharts fill/stroke props, inline styles). Mirrors the `brand.*`
// colors in tailwind.config.js — keep the two in sync.
export const BRAND = {
  navy: '#070B5F',
  navyDeep: '#030524',
  navyLight: '#0F1780',
  accent: '#6BA82E',
  accentBright: '#8DC63F',
  accentSoft: '#A6E56C',
};
